import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_FISCALYEAR = 'FETCH_FISCALYEAR'
export const FETCH_FISCALYEAR_SUCCESS = 'FETCH_FISCALYEAR_SUCCESS'
export const FETCH_FISCALYEAR_FAILURE = 'FETCH_FISCALYEAR_FAILURE'
export const CHANGE_FISCALYEAR = 'CHANGE_FISCALYEAR'

export function loadFiscalyear() {
  return (dispatch) => {
    dispatch(fetchFiscalyear())
    axios({
      method: 'GET',
      url: URIS.fiscalyear,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchFiscalyearSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchFiscalyearFailure(errorMessage(error)))
      })
  }
}

function fetchFiscalyear() {
  return {
    type: FETCH_FISCALYEAR
  }
}

function fetchFiscalyearSuccess(payload) {
  return {
    type: FETCH_FISCALYEAR_SUCCESS,
    payload
  }
}

function fetchFiscalyearFailure(payload) {
  return {
    type: FETCH_FISCALYEAR_FAILURE,
    payload
  }
}

export function changeFiscalyear(payload) {
  return {
    type: CHANGE_FISCALYEAR,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/FiscalYear.js